import { AuthType } from './AuthType';

/**
 * login_error
 * Ошибка авторизации
 */
export interface LoginError {
  /**
   * какая ошибка, передать тип или текст заголовка ошибки
   */
  errorType: string;

  type?: AuthType;
}

export function mapLoginErrorEvent(event: LoginError): object {
  const props: Record<string, unknown> = {
      error_type: event.errorType,
      type: event.type,
  };

  return {
    event: 'analytics_event',
    event_name: 'login_error',
    event_properties: Object.fromEntries(
      Object.entries(props)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    ),
  };
}
